import { Injectable, WritableSignal, signal, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable, catchError, map, of } from 'rxjs';
import * as Sentry from '@sentry/browser';

import { GlobalsService } from '@services/globals.service';
import { Navigation, NavigationResponse } from '@models/strapi';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  private http = inject(HttpClient);
  private globalsService = inject(GlobalsService);
  public navigation: WritableSignal<Navigation[] | undefined> = signal(undefined);

  getData(): Observable<Navigation[]> {
    return this.http.get<Navigation[]>(environment.strapiNavigationApi, { headers: this.globalsService.headerHash() }).pipe(
      map((response) => {
        if (!response) {
          this.navigation.set([]);
          return [];
        }
        const navigationArray = Array.isArray(response) ? response : [response];
        const sortedNavigation = navigationArray.sort((a, b) => a.rank - b.rank);
        this.navigation.set(sortedNavigation);
        return sortedNavigation;
      }),
      catchError((e) => {
        Sentry.captureMessage('Nepodařilo se načíst navigace - Error: ' + e.message, { level: 'fatal' });
        this.navigation.set([]);
        return of([]);
      }),
    );
  }
}
